import React, { useState } from "react";
import "./ContactBar.scss";

const ContactBar = () => {
  const [isPhoneVisible, setIsPhoneVisible] = useState(false);

  const togglePhone = () => {
    setIsPhoneVisible(!isPhoneVisible);
  };

  return (
    <>
      {/* Bottone Contattaci in basso a destra */}
      <button 
        className={`contact-bar__button ${isPhoneVisible ? "contact-bar__button--hidden" : ""}`} 
        onClick={togglePhone}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M15 18l-6-6 6-6" />
        </svg>
        Contact Us
      </button>

      {/* Barra con numero di telefono che occupa tutta la larghezza */}
      <div className={`contact-bar ${isPhoneVisible ? "contact-bar--visible" : ""}`}>
        <a href="tel:+390363380100" className="contact-bar__link">
          +39 0363 38 01 00
        </a>
        <button className="contact-bar__close" onClick={togglePhone} aria-label="Close">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
          <span>Close</span>
        </button>
      </div>
    </>
  );
};

export default ContactBar;

